<div class="main-loader--wrapper">
    <span class="main-loader"></span>
</div>
